<template>
   <artmisads-modal
    v-model:open="visible"
    :title="$t('seller.common.notice')"
    :width="600"
    :maskClosable="false"
    @cancel="handleCancel"
    :footer="null"
  >
    <div>
      <!-- <div class="tags-container">
          <div class="title">Select Publishers</div>
          <a-tag
            v-for="tag in editData"
            :key="tag.brandId"
            color="blue"
            class="tag-item"
          >
            {{ tag.creatorName }} 
          </a-tag>
      </div> -->
      <div class="title">
        {{ $t('seller.brandsPage.partneredActiveTitle') }}
      </div>
      <div class="tags-container">
          <div v-for="tag in editData" :key="tag.brandId" class="tag-item">
            <LogoImage :maxWidth="'95%'" :logoUrl="tag?.publicImage" :brandName="tag?.creatorName" :width="20"
            :height="20" :lineHeight="6" :fontSize="5" :borderRadius="4" />
            <span>{{ tag.creatorName }} </span>
          </div>
        </div>
        <div>
          
        </div>
        <div class="content">
          <div class="content-item"> 
            <SvgIcon name="info-tianchong" class="icon-info" />
            <span>{{ $t('seller.brandsPage.partneredOriginalDates') }}</span>
          </div>
          <div class="content-item"> 
            <SvgIcon name="info-tianchong" class="icon-info" />
            <span>{{ $t('seller.brandsPage.partneredCommissionNote') }}</span>
          </div>
          
        </div>
      <!-- <div>The publishers below have active partnerships:</div>
      <div>Original start dates will be preserved</div>
      <div>Current commission rates apply for this month</div>
      <div>Changes will take effect next month cycle</div> -->
      
      <div class="modal-footer">
       
       <artmisads-button :isSquare="true" type="primary" @click="handleSave" :loading="saving">
        {{ $t('seller.common.confirm') }}
       </artmisads-button>
     </div>
    </div>
  </artmisads-modal>
</template>

<script setup>
import { ref } from 'vue';
import LogoImage from '@/components/LogoImage.vue';
import SvgIcon from '~/components/SvgIcon.vue';

const visible = ref(false);
const editData = ref([]);
const emit = defineEmits(['confirm','saving'])
const handleCancel = () => {
  visible.value = false;
};
const open = (initialData) => {
  visible.value = true;
  editData.value = initialData;
};
const handleSave = () => {
  emit('confirm')
  visible.value = false;
};
defineExpose({
  open
});
</script>

<style scoped lang="less">
.title{
  color: #000000;
 font-family: "Sora";
 font-size: 13px;
 font-style: normal;
 font-weight: 400;
 line-height: 15px;
 letter-spacing: 0.3px;
 padding-top:8px;
 margin-bottom: 10px;
}
    .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding-bottom: 24px;
    .tag-item {
      display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #F1F0F5;
      // margin: 4px 8px 4px 0;
      // padding: 4px 8px;
   
      font-size: 13px;

 font-weight: 400;
 line-height: 15px;
 letter-spacing: 0.3px;

     span{
      font-family: "Sora";
 opacity: 0.7;
 color: #0f0629;
     }
    }
    
  
  }
  .content{
   border-radius: 8px;
background: #50408014;
.content-item{
 display: flex;
 align-items: flex-start;
 gap: 6.8px;
 padding: 12px;
 span{
  font-family: "Sora";
 font-size: 13px;
 font-style: normal;
 font-weight: 400;
 line-height: 20px;
 letter-spacing: 0.3px;
 word-wrap: break-word;
 }
 :deep(.icon){
    fill: #835CF2;
  }
  .icon-info{
    padding-top: 2.5px;
    font-size: 16px;
  }
}
  }
  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;
    .cancel-button{
      min-width: 96px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0f0629;
      font-family: "Sora";
      font-size: 14px;
 font-weight: 500;

 letter-spacing: 0.4px;
 opacity: 0.7;
    }
    .artmisads-button {
      min-width: 96px;
      font-family: "Sora";
      font-weight: 500;
    }
  }
</style>